var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"slogan"},[_c('img-retina',{attrs:{"src":"/images/top/slogan_bottom.svg","alt":"新しいモノづくりを一緒に。","width":1020}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }